import { Link } from 'react-router-dom';

const CTA_BG = 'https://readdy.ai/api/search-image?query=happy%20Brazilian%20family%20with%20child%20smiling%20in%20garden%2C%20warm%20golden%20hour%20sunlight%2C%20parents%20and%20child%20together%2C%20joy%20and%20confidence%2C%20outdoor%20setting%20with%20green%20nature%20background%2C%20emotional%20and%20uplifting%20family%20portrait&width=1400&height=700&seq=cta001&orientation=landscape';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-40 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${CTA_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy-dark/50 via-navy-dark/60 to-navy-dark/75" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <p className="text-white/60 text-xs font-700 font-sans uppercase tracking-[0.3em] mb-5 md:mb-6">
          DÊ O PRIMEIRO PASSO
        </p>
        <h2 className="font-serif text-3xl md:text-5xl font-600 text-white mb-5 md:mb-6 leading-tight">
          Rumo à clareza e tranquilidade
        </h2>
        <p className="text-white/75 text-base md:text-xl font-sans font-300 max-w-xl mx-auto leading-relaxed mb-8 md:mb-12">
          Seu filho merece ser compreendido. Você merece respostas. 
          Estamos aqui para trilhar esse caminho juntos.
        </p>

        <a
          href="https://wa.me/5511981882825"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-0 bg-black text-white rounded-full overflow-hidden cursor-pointer group transition-all duration-200 hover:shadow-xl"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-coral group-hover:bg-coral-dark transition-colors rounded-full -mr-2 z-10">
            <i className="ri-whatsapp-line text-white text-xl" />
          </div>
          <span className="px-6 md:px-8 text-sm font-700 font-sans uppercase tracking-widest">
            Agendar Avaliação
          </span>
          <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center mr-2">
            <i className="ri-arrow-right-up-line text-white/60 text-lg" />
          </div>
        </a>

        <p className="mt-6 md:mt-8 text-white/50 text-xs font-sans flex flex-wrap items-center justify-center gap-3 md:gap-4">
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line text-coral/70" />
            Atendimento presencial e online
          </span>
          <span className="hidden sm:block w-1 h-1 rounded-full bg-white/30" />
          <span className="flex items-center gap-1">
            <i className="ri-shield-check-line text-coral/70" />
            Conformidade LGPD
          </span>
        </p>
      </div>
    </section>
  );
}
